import { api } from '@/f1/service';
import { saveAs } from 'file-saver/FileSaver';
import moment from 'moment-timezone';
import _ from 'lodash'
import Schedule from '../../agent/Schedule.i18n'
import codes from '../../../../codes'

//restful api
// import { wsfinder as wf } from '@/f1/service/api';

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  props : ['id', 'result_data'],
  components : {
    Schedule
  },
  // computed : {

  // },
  data : () => {
    return {
      codes,
      moment,
      model : { setting : { schedule : [] } },
      detect_list : "",
      converter : '',
    }
  },
  methods: {
    save_rs() {
      let data = _.map(this.model.detect_list, d => {
        if(d.description) {
          return `[${d.description.type}] [${d.description.code}|line:${d.description.numerical ? d.description.numerical : '-'}]  ${d.description.value} ${d.path}` + '\r\n'
        }

        return d + '\r\n'
      })
      if(!data.length) { this.$toastr.i(`${i18n_toastr._i18n_info.webShell_detect[this.i18n]}`); return; }
      let blob = new Blob(data, {type: "text/plain;charset=utf-8"});
      saveAs(blob, 'webshell_list.txt');
    },
    list() { this.$router.push({ name: 'wsfinder_result'}); },
    async get({ id } = this.$route.params) {
      console.log('result.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; return; }
      try {
        if(!this.result_data) {
          let rs = await api.wsfinder.WSFinder_Call('result', 'detail', { id : this.id ? this.id : id })
          //let rs = await wf.result.detail({ id : this.id ? this.id : id })
          this.model = Object.assign({ group: {}, agent : { is_allow_system : true } }, this.model, rs.body)
        } else {
          this.model = Object.assign({ group: {}, agent: { settong : {}, is_allow_system : true } }, this.result_data)
          if(typeof "" == typeof this.model.detect_list) {
            this.model.detect_list = JSON.parse(this.model.detect_list)
          }
        }

        // console.log('this.model.detect_list', this.model.detect_list)

        this.detect_list = _.join(_.map(this.model.detect_list, d => {
          if(d.description) {
            d.description =  typeof '' == typeof d.description ? JSON.parse(d.description) : d.description
            return `[${d.description.type}] [${d.description.code}|line:${d.description.numerical ? d.description.numerical : '-'}]  ${d.description.value} ${d.path}`
          }

          return d
        }), '\r\n')

        if(this.model.setting && typeof this.model.setting == typeof '') {
          this.model.setting = JSON.parse(this.model.setting)
          if(typeof this.model.setting == typeof '') {
            this.model.setting = JSON.parse(this.model.setting)
          }

          if(this.model.setting.ext_list.length) { this.converter = _.join(this.model.setting.ext_list, ','); }

          if(this.model.setting.schedule.length) {
            try {
              for (let l = 0; l < this.model.setting.schedule.length; l++) {
                let x = _.filter(codes.WSF_SCHEDULE_i18n[this.i18n], x => x.value == this.model.setting.schedule[l].day)
                if(x.length < 1) { continue }
                this.model.setting.schedule[l].name = x[0].text
              }

            } catch (error_schedule) {
              console.log(error_schedule)
            }
          }
        }
        let sec = moment(this.model.created_at).diff(moment(this.model.scan_time), 'seconds')
        this.model.scanning_time =  `${Math.floor(sec / 60) < 0 ? 0 : Math.floor(sec / 60)}:${`${sec % 60 < 0 ? 0 : sec % 60}`.padStart(2, '0')}`
        console.log(this.model.scanning_time, sec, moment(this.model.created_at).format('HH:mm:ss'), moment(this.model.scan_time).format('HH:mm:ss'))

      } catch(e) { console.log(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params, from); } },
  created: function() {   console.log('result.detail.vue', 'created'); },
  destroyed: function() { console.log('result.detail.vue', 'destroyed'); },
  mounted: function() {
    console.log('result.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
